import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IUpdateNoteInterventionRequest from 'services/httpClient/requests/intervention/IUpdateNoteInterventionRequest';
import IUpdateNoteInterventionResponse from 'services/httpClient/responses/intervention/IUpdateNoteInterventionResponse';

import { interventionActions } from '../index';
import { IUpdateNoteInterventionRequestAction } from '../reducers/updateNote/request';

function* updateNote(
  action: PayloadAction<IUpdateNoteInterventionRequestAction>,
) {
  try {
    const body: IUpdateNoteInterventionRequest = {
      text: action.payload.data.text,
      archived: action.payload.data.archived,
    };

    const response: AxiosResponse<IUpdateNoteInterventionResponse> = yield call(
      rikHttpClient.put,
      `interventions/${action.payload.data.id}/update_note`,
      body,
    );

    yield put(
      interventionActions.updateNoteSuccess({
        note: response.data,
        isArchive: action.payload.data.archived,
      }),
    );
    action.payload.functions.close();
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.updateNoteFailure());
  }
}

export default updateNote;
